import React from "react";
import "./Style.css";

const Modal = ({ isOpen, onClose, onConfirm, title, dialog, showButtons }) => {
  if (!isOpen) return null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h4 className="modal-title-cls">{title}</h4>
          <button className="modal-close-button" onClick={onClose}>
            ×
          </button>
        </div>
        <div className="modal-body">
          <p className="dialog">{dialog}</p>
        </div>
        <div className="modal-footer">
          {showButtons && (
            <button className="modal-confirm-button" onClick={onConfirm}>
              Yes
            </button>
          )}
          {showButtons && (
            <button className="modal-cancel-button" onClick={onClose}>
              No
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default Modal;
